module.exports = __webpack_public_path__ + "media/images/Composz-logo-white-trans-68a3068d.png";